import React from 'react';

const Alert = () => {
  return (
    <div className="alert">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="80"
        height="80"
        viewBox="0 0 80 80"
      >
        <g fill="#00b270" fillRule="nonzero">
          <path d="M43.429 19.956v26.637a3.527 3.527 0 0 1-3.517 3.517 3.527 3.527 0 0 1-3.516-3.517V19.956a3.527 3.527 0 0 1 3.516-3.516 3.527 3.527 0 0 1 3.517 3.516z" />
          <circle cx="39.824" cy="59.692" r="3.604" />
          <path d="M39.824 7.297c17.934 0 32.616 14.593 32.616 32.527S57.846 72.352 39.824 72.352 7.21 57.758 7.21 39.824c0-17.934 14.593-32.527 32.615-32.527m0-7.033C17.934.264.176 17.934.176 39.824s17.758 39.56 39.648 39.56c21.89 0 39.649-17.67 39.649-39.56C79.385 18.022 61.714.264 39.824.264z" />
        </g>
      </svg>
    </div>
  );
};

export default Alert;
